<template>
    <ValidationObserver v-slot="{ invalid }">
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Rabatte</h6>
            </div>
            <div class="card-body">

                <div class="form-group">
                    <label>Bieten Sie Kundenkartenrabatte an?</label>
                    <select type="text" class="form-control" v-model="config.kundenkarten">
                        <option :value="false">Nein</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>

                <div class="form-group" v-if="config.kundenkarten">
                    <label>Wie viel Prozent erstatten sie auf Kundenkarten?</label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control" placeholder="00,00"
                                   v-model="config.kundenkartenRabatt">
                        </div>
                        <div class="text-danger">{{ errors[0] }}</div>
                    </ValidationProvider>
                </div>

                <div class="form-group" v-if="config.kundenkarten">
                    <label>Geben Sie einen Vorgang ein:</label>
                    <rabatt-vorgaenge :dto="config.kundenkartenVorgaenge"></rabatt-vorgaenge>
                </div>

                <hr>

                <div class="form-group">
                    <label>Nutzen Sie zusätzliche Rabatte wie Coupons? (ausgenommen Hersteller Aktionen)</label>
                    <select type="text" class="form-control" v-model="config.coupons">
                        <option :value="false">Nein</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>

                <div class="form-group" v-if="config.coupons">
                    <label>Wie viel Prozent erstatten sie auf Coupons?</label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control" placeholder="00,00"
                                   v-model="config.couponsRabatt">
                        </div>
                        <div class="text-danger">{{ errors[0] }}</div>
                    </ValidationProvider>
                </div>

                <div class="form-group" v-if="config.coupons">
                    <label>Geben Sie einen Vorgang ein:</label>
                    <rabatt-vorgaenge :dto="config.couponsVorgaenge"></rabatt-vorgaenge>
                </div>

                <hr>

                <div class="form-group">
                    <label>Geben Sie Mitarbeiter-Rabatte?</label>
                    <select type="text" class="form-control" v-model="config.mitarbeiterRabatte">
                        <option :value="false">Nein</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>

                <div class="form-group" v-if="config.mitarbeiterRabatte">
                    <label>Wie werden die Rabatte berechnet? Bitte wählen Sie die Umsatzbasis aus:</label>
                    <select type="text" class="form-control" v-model="config.mitarbeiterBasis">
                        <option value="listenek">Listen EK</option>
                        <option value="nettoek">Netto EK</option>
                        <option value="listenvk">Listen VK</option>
                        <option value="kalkuliertervk">Kalkulierter VK</option>
                    </select>
                </div>

                <div class="form-group" v-if="config.mitarbeiterRabatte">
                    <label>Wie hoch ist der Aufschlag?</label>
                    <div class="row">
                        <div class="col">
                            <select type="text" class="form-control" v-model="config.mitarbeiterAufschlag">
                                <option value="mwst">Mehrwertsteuer</option>
                                <option value="prozent">Individueller Prozentwert</option>
                                <option value="euro">Individueller Eurowert</option>
                            </select>
                        </div>
                        <div class="col" v-if="config.mitarbeiterAufschlag !== 'mwst'">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" v-if="config.mitarbeiterAufschlag === 'prozent'">%</span>
                                        <span class="input-group-text" v-if="config.mitarbeiterAufschlag === 'euro'">€</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="00,00"
                                           v-model="config.mitarbeiterAufschlagWert">
                                </div>
                                <div class="text-danger">{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <div class="form-group" v-if="config.mitarbeiterRabatte">
                    <label>Geben Sie einen Vorgang ein:</label>
                    <rabatt-vorgaenge :dto="config.mitarbeiterVorgaenge"></rabatt-vorgaenge>
                </div>

            </div>
        </div>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Lagerkennzeichnung</h6>
            </div>
            <div class="card-body">

                <div class="form-group">
                    <label>Pflegen Sie regelmäßig und gewissenhaft ihre Lagerorte?</label>
                    <select type="text" class="form-control" v-model="config.lager">
                        <option :value="false">Nein</option>
                        <option :value="true">Ja</option>
                    </select>
                </div>

                <div class="form-group" v-if="config.lager">
                    <label>Geben Sie zwei Vorgänge mit Kennzeichnung <b>Lagerartikel = Nein</b> ein:</label>
                    <lager-vorgaenge :dto="config.lagerNeinVorgaenge"></lager-vorgaenge>
                </div>

                <div class="form-group" v-if="config.lager">
                    <label>
                        Geben Sie vier Vorgänge mit Kennzeichnung <b>Lagerartikel = Ja</b> ein:
                        <br>
                        <small>Bitte unterschiedliche Lagerorte aufführen.</small>
                    </label>
                    <lager-vorgaenge :dto="config.lagerJaVorgaenge"></lager-vorgaenge>
                </div>

            </div>
        </div>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Kennzeichnung</h6>
            </div>
            <div class="card-body">

                <div class="form-group">
                    <label>
                        Bitte geben Sie einen Vorgang zu bestands- und statistikneutralen Verkäufen an:
                        <br>
                        <small>Produkte für die Rezeptur:</small>
                    </label>
                    <bestands-vorgaenge :dto="[config.bestandsVorgaenge[0]]"></bestands-vorgaenge>
                </div>

                <div class="form-group">
                    <label>
                        Bitte geben Sie einen Vorgang zu bestands- und statistikneutralen Verkäufen an:
                        <br>
                        <small>Produkte für die Verblisterung:</small>
                    </label>
                    <bestands-vorgaenge :dto="[config.bestandsVorgaenge[1]]"></bestands-vorgaenge>
                </div>

                <div class="form-group">
                    <label>
                        Bitte geben Sie zwei Vorgänge zu Neinverkäufen an:
                        <br>
                        <small>Kunde kommt in die Apotheke, Artikel ist nicht vorrätig und wird als Neinverkauf erfasst.</small>
                    </label>
                    <nein-vorgaenge :dto="config.neinVorgaenge"></nein-vorgaenge>
                </div>

                <div class="form-group">
                    <label>
                        Bitte geben Sie einen Vorgang für Rückgaben an den <b>Großhandel</b> an:
                    </label>
                    <retouren-vorgaenge :dto="config.retourenGh"></retouren-vorgaenge>
                </div>

                <div class="form-group">
                    <label>
                        Bitte geben Sie einen Vorgang für Rückgaben an den <b>Direktlieferanten</b> an (Warenausgleich ausgenommen):
                    </label>
                    <retouren-vorgaenge :dto="config.retourenDirekt"></retouren-vorgaenge>
                </div>

            </div>
        </div>

        <button type="submit" class="btn btn-primary" :disabled="invalid" v-if="!readonly">
            Speichern
            <span v-if="invalid">(es fehlen Eingaben)</span>
        </button>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
    </ValidationObserver>
</template>

<script>

// validation
import {extend} from 'vee-validate';
import {required, regex} from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'Dies ist ein Pflichtfeld.'
});
extend('regex', {
    ...regex,
    message: 'Falsches Format.'
});


import RabattVorgaenge from "./RabattVorgaenge";
import LagerVorgaenge from "./LagerVorgaenge";
import BestandsVorgaenge from "./BestandsVorgaenge";
import NeinVorgaenge from "./NeinVorgaenge";
import RetourenVorgaenge from "./RetourenVorgaenge";

export default {
    components: {RetourenVorgaenge, BestandsVorgaenge, NeinVorgaenge, LagerVorgaenge, RabattVorgaenge},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            config: this.dto,
        };
    },
    methods: {},
    computed: {}
}
</script>
